import * as React from 'react'
import { ReactNode } from 'react'

interface ICardListEmptyProps {
  message?: ReactNode
}

const CardListEmpty: React.FC<ICardListEmptyProps> = ({ message }) => {
  return (
    <div className="tw:flex tw:items-center tw:justify-center tw:flex-1 tw:w-full tw:min-h-[200px]">
      <span className="tw:text-body-md tw:text-muted-foreground">
        {message}
      </span>
    </div>
  )
}

export default CardListEmpty
